/** @module Specification/CareAndComposition/CareIconPerLanguageRendererMixin */
define([
	"dojo/_base/declare"
], function(declare) {

	return declare(null, {
		bBaseRenderer: true,

		/**
		 * Extract attribute value
		 * @param {Context} ctx
		 * @param {Heading} h
		 */
		_getValue: function(ctx, h) {
			// default processing
			var v = this.inherited(arguments);

			// if we didn't get a value, try looking at default value of Images
			var	node = ctx.getNode();
			if (!v && node && node.Images)
				v = node.Images[""];

			return v;
		}
	});
});
